// extracted by mini-css-extract-plugin
export default {"animated":"LoadingIcon_animated__fodQB","spin":"LoadingIcon_spin__3uPn2"};